<div class="crm-activities-container">

  <div class="crm-task-list-container">

    <mat-nav-list style="padding-top: 0">

      <a *ngFor="let item of items"
         mat-list-item
         [class.list-item-active]="item === selectedItem"
         (click)="onSelect(item)">

        <mat-icon matListIcon class="crm-task-list-icon"> assignment </mat-icon>

        <p mat-line>
          {{item.name}}
        </p>

        <p mat-line>
          {{item.description}}
        </p>

      </a>

    </mat-nav-list>

  </div>

  <div class="crm-task-container">
    <flow-task (completeEvent)="onCompleteEvent($event)" [task]="selectedItem"> </flow-task>
  </div>

</div>

<!--

(completeEvent)="onCompleteEvent()"

         [class.selected]="item === selectedItem"

      <a *ngFor="let item of myWorkRoutes"
         mat-list-item
         (click)="sidenav.close()"
         routerLinkActive
         #routerLinkActiveInstance="routerLinkActive"
         [class.list-item-active]="routerLinkActiveInstance.isActive"
         [routerLink]="[item.route]">
        <mat-icon matListIcon class="app-nav-list-icon"> {{ item.icon }} </mat-icon>
        {{item.title}}
      </a>

         (click)="onSelect(item)">

      <a mat-list-item routerLink="/" style="height: 0;"></a>

-->

<!--

<mat-nav-list>

  <a mat-list-item routerLink="/" style="height: 0;"></a>

  <a *ngFor="let item of items"
     mat-list-item>

    <mat-icon matListIcon class="crm-task-list-icon"> assignment </mat-icon>

    <p mat-line>
      {{item.name}}
    </p>

    <p mat-line>
      {{item.description}}
    </p>

  </a>

</mat-nav-list>

-->


